var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBuyBtn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5C5F62",
  d: "M1.6 2.562c0-.53.43-.96.96-.96h10.88c.53 0 .96.43.96.96v3.84c0 .53-.43.96-.96.96H9.67a.96.96 0 0 1-.96-.96v-1.53a.711.711 0 0 0-1.422 0v1.53c0 .53-.43.96-.96.96H2.56a.96.96 0 0 1-.96-.96z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#5C5F62",
  fillRule: "evenodd",
  d: "M6.08 4.802a1.92 1.92 0 0 1 3.84 0v2.805a.32.32 0 0 0 .228.307l1.724.517a1.6 1.6 0 0 1 1.124 1.759l-.405 2.838a1.6 1.6 0 0 1-1.584 1.374H6.054a1.6 1.6 0 0 1-1.453-.93l-1.318-2.857a1.55 1.55 0 0 1-.069-1.137c.134-.389.46-.742.97-.815.663-.094 1.29.123 1.896.525zM8 4.162a.64.64 0 0 0-.64.64v4.987c0 .89-1.03 1.23-1.618.743-.606-.502-1.018-.632-1.324-.607a.31.31 0 0 0 .027.154l1.318 2.857a.32.32 0 0 0 .29.186h4.954a.32.32 0 0 0 .317-.275l.405-2.838a.32.32 0 0 0-.225-.352L9.78 9.14a1.6 1.6 0 0 1-1.14-1.533V4.802a.64.64 0 0 0-.64-.64",
  clipRule: "evenodd"
})));
export default SvgBuyBtn;